import FooterCalloutRepository from "../FooterCalloutRepository"

export default class DemoFooterCallout extends FooterCalloutRepository {
    static schemaId = "demo_footerCallout"

    constructor() {
        super(DemoFooterCallout.schemaId)
    }
}
